export default __webpack_public_path__ + "static/media/ost_site_logo.149dbe3a.png";